<template lang="pug">
  .component-extra-fields
    h2 Extra
    .row
      .columns(v-for="(value, label) in fields")
        label {{label}}
          input(type="text", v-model="fields[label]")

</template>

<script>

  import {mapState} from 'vuex'

  export default {
    name: 'ClientExtraFields',
    data() {
      return {}
    },
    mounted() {
      console.log(this.configuration.system.system_client_custom_fields.value)

    },
    methods: {},
    props: {
      fields: {},
    },
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      })
    }
  }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// ClientExtraFields.vue?3429a0c2